// extracted by mini-css-extract-plugin
export default {"blogPageContainer":"BlogPage_blogPageContainer__ln+I4","title":"BlogPage_title__p8Pst","body":"BlogPage_body__Y4JRa"};